// extracted by mini-css-extract-plugin
export default {"image":"wY-z","loaded":"xY-z"};